import { render, staticRenderFns } from "./ItemsServicesBid.vue?vue&type=template&id=2f86df28&scoped=true&"
import script from "./ItemsServicesBid.vue?vue&type=script&lang=js&"
export * from "./ItemsServicesBid.vue?vue&type=script&lang=js&"
import style0 from "./ItemsServicesBid.vue?vue&type=style&index=0&id=2f86df28&lang=scss&scoped=true&"
import style1 from "./ItemsServicesBid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86df28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f86df28')) {
      api.createRecord('2f86df28', component.options)
    } else {
      api.reload('2f86df28', component.options)
    }
    module.hot.accept("./ItemsServicesBid.vue?vue&type=template&id=2f86df28&scoped=true&", function () {
      api.rerender('2f86df28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/ItemsServicesBid.vue"
export default component.exports